export default __webpack_public_path__ + "static/media/illust_empty_goal_character.26f0792e.svg";